import http from './http'

const ContestUserSecurity = {
  getByParams: (params) => http.get('/api/contest-user-securities/', { params })
}

export default ContestUserSecurity
